import { ClassLevelOverrideOptions, SchoolSettingsOptions } from '../../types/adminConfig';

interface ShowSettingsProps {
    options?: SchoolSettingsOptions;
    overrideName: keyof SchoolSettingsOptions; // todo: overrides will be in their own type
    parentPage: string;
}

export const showSettings = ({ options, overrideName, parentPage }: ShowSettingsProps) => {
    const orgOverrideDefined = options?.[overrideName] !== undefined;

    if (!orgOverrideDefined) {
        return false;
    }

    if (parentPage === 'adminSettings') {
        return options?.[overrideName] !== ClassLevelOverrideOptions.NoOne;
    }

    return options?.[overrideName] === ClassLevelOverrideOptions.AdminsAndInstructors;
};
